// asset-source 폴더의 파일 목록 → Bulk Episode Ingest 업로드용 CSV 생성 (BEE-4996).
// bulk-episode 템플릿과 동일한 헤더를 사용하고, video_path 만 채워 그대로 붙여넣어 쓰게 한다.

// bulk-episode 템플릿과 반드시 동일하게 유지할 것. (제목은 시즌명+화수로 자동 생성되므로 title 컬럼 없음)
export const BULK_EPISODE_CSV_HEADER =
  'episode_no*,video_path*,on_air_date,publish_date,slug,episode_order';

export const ASSET_SOURCE_ROOT_PREFIX = 'backedup/';

/** S3 키(backedup/.../ep1.mp4)를 bulk-ingest video_path(= backedup/ 제외 상대경로)로 변환 */
export const keyToVideoPath = (key: string): string =>
  key.startsWith(ASSET_SOURCE_ROOT_PREFIX) ? key.slice(ASSET_SOURCE_ROOT_PREFIX.length) : key;

/** CSV 필드 이스케이프: 쉼표/따옴표/개행 포함 시 큰따옴표로 감싸고 내부 따옴표는 중복 처리 */
export const csvEscape = (value: string): string =>
  /[",\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

/**
 * video_path 만 채우고 episode_no/episode_order 는 정렬순 1..N 자동 채움.
 * 나머지(title 등)는 공란으로 두어 운영자가 채우게 한다. BOM 포함(엑셀 한글 호환).
 */
export const buildBulkEpisodeCsv = (videoPaths: string[]): string => {
  const rows = videoPaths.map((vp, i) => {
    const n = String(i + 1);
    // episode_no, video_path, on_air_date, publish_date, slug, episode_order
    return [n, csvEscape(vp), '', '', '', n].join(',');
  });
  return `﻿${BULK_EPISODE_CSV_HEADER}\n${rows.join('\n')}\n`;
};
